<template>
  <svg
    width="107"
    height="18"
    viewBox="0 0 107 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-if="size == 'large'"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M32.5348 9.50022V13.3891C31.3169 14.3336 29.6061 14.9447 27.7212 14.9447C24.5025 14.9447 21.8638 12.528 21.8638 9.528C21.8638 6.52799 24.5025 4.11133 27.7212 4.11133C29.5771 4.11133 31.0849 4.69466 32.1578 5.63911L30.7369 7.13911C30.012 6.50022 28.9391 6.13911 27.7212 6.13911C25.7494 6.13911 24.1546 7.66688 24.1546 9.528C24.1546 11.5002 25.7494 13.028 27.7212 13.028C28.7071 13.028 29.5771 12.7502 30.302 12.3058V11.3058H27.4892V9.50022H32.5348Z"
        fill="#404041"
      />
      <path
        d="M36.1304 11.306C36.3623 12.3615 37.2613 13.1115 38.5661 13.1115C39.465 13.1115 40.306 12.7227 40.7699 12.1115L42.1618 13.2227C41.3789 14.2504 39.987 14.9171 38.3052 14.9171C35.7244 14.9171 33.9556 13.0282 33.9556 10.6949C33.9556 8.36155 35.7534 6.47266 38.3052 6.47266C40.9149 6.47266 42.4518 8.27821 42.4518 10.8338C42.4518 11.0004 42.4228 11.1671 42.4228 11.306H36.1304ZM36.1304 9.97266H40.364C40.277 9.02821 39.755 8.1671 38.3052 8.1671C37.1453 8.1671 36.3333 8.97266 36.1304 9.97266Z"
        fill="#404041"
      />
      <path
        d="M57.5593 10.2504V14.806H55.3845V10.2504C55.3845 9.00043 54.7176 8.36155 53.5287 8.36155C52.8038 8.36155 52.2818 8.61155 51.8468 9.00043C51.9338 9.22266 51.9338 9.52821 51.9338 10.2504V14.7782H49.759V10.2504C49.759 9.00043 49.1791 8.36155 48.0482 8.36155C47.2653 8.36155 46.6563 8.61155 46.2214 9.00043V14.7782H44.0176V6.63932H46.2214V7.13932C46.8303 6.72266 47.6132 6.47266 48.4252 6.47266C49.73 6.47266 50.658 6.77821 51.2379 7.50043C51.9628 6.86155 52.8907 6.47266 53.9057 6.47266C56.3994 6.47266 57.5593 7.61155 57.5593 10.2504Z"
        fill="#404041"
      />
      <path
        d="M64.1126 4.19482C67.3603 4.19482 68.4332 6.02816 68.4332 8.00038C68.4332 10.8893 66.4614 12.0559 63.6487 12.0559H61.7929V14.7782H59.5601V4.19482H64.1126ZM63.4457 10.2782C65.2435 10.2782 66.0844 9.41705 66.0844 8.16705C66.0844 7.05594 65.4755 6.05594 63.7357 6.05594H61.7929V10.2782H63.4457Z"
        fill="#808184"
      />
      <path
        d="M78.1766 6.63932V14.806H76.0018V14.1949C75.3059 14.6393 74.4359 14.9171 73.508 14.9171C70.8403 14.9171 69.2744 12.8615 69.2744 10.6949C69.2744 8.52821 70.8403 6.47266 73.508 6.47266C74.4069 6.47266 75.2769 6.75043 76.0018 7.13932V6.63932H78.1766ZM76.0018 9.08377C75.4798 8.63932 74.7259 8.38932 73.885 8.38932C72.3191 8.38932 71.3622 9.50043 71.3622 10.7227C71.3622 11.9449 72.3481 13.056 73.885 13.056C74.7259 13.056 75.4508 12.806 76.0018 12.3615V9.08377Z"
        fill="#808184"
      />
      <path
        d="M88.7316 6.63894V13.2501C88.7316 15.3612 87.5138 17.6667 84.2661 17.6667C82.1493 17.6667 81.7433 17.5001 80.4384 17.1389L80.8734 15.5834C81.8013 15.8334 82.5842 16.0556 83.7731 16.0556C85.078 16.0556 86.4119 15.3056 86.4699 14.0278C85.7739 14.3889 84.962 14.6112 84.0921 14.6112C81.7143 14.6112 79.7715 12.9723 79.7715 10.5556C79.7715 8.11117 81.7143 6.52783 84.0921 6.52783C84.991 6.52783 85.8609 6.75005 86.5858 7.13894V6.66672H88.7316V6.63894ZM84.44 12.6945C85.281 12.6945 86.0349 12.4445 86.5568 12.0278V9.02783C86.0349 8.61117 85.281 8.36117 84.44 8.36117C82.9902 8.36117 81.8883 9.30561 81.8883 10.5278C81.8883 11.8334 82.9902 12.6945 84.44 12.6945Z"
        fill="#808184"
      />
      <path
        d="M92.4722 11.306C92.7041 12.3615 93.6031 13.1115 94.9079 13.1115C95.8068 13.1115 96.6478 12.7227 97.1117 12.1115L98.5036 13.2227C97.7207 14.2504 96.3288 14.9171 94.647 14.9171C92.0662 14.9171 90.2974 13.0282 90.2974 10.6949C90.2974 8.36155 92.0952 6.47266 94.647 6.47266C97.2567 6.47266 98.7936 8.27821 98.7936 10.8338C98.7936 11.0004 98.7646 11.1671 98.7646 11.306H92.4722ZM92.5012 9.97266H96.7348C96.6478 9.02821 96.1258 8.1671 94.676 8.1671C93.5161 8.1671 92.7041 8.97266 92.5012 9.97266Z"
        fill="#808184"
      />
      <path
        d="M100.708 12.5833C101.751 13.0278 102.563 13.25 103.636 13.25C104.651 13.25 105.028 12.8889 105.028 12.4722C105.028 12 104.535 11.8056 103.23 11.5278C101.403 11.1389 100.07 10.5556 100.07 9C100.07 7.52778 101.345 6.5 103.317 6.5C104.651 6.5 105.724 6.80556 106.652 7.16667L105.927 8.69444C105.086 8.38889 104.129 8.16667 103.288 8.16667C102.447 8.16667 102.041 8.44444 102.041 8.88889C102.041 9.33333 102.563 9.55556 103.926 9.83333C105.898 10.2222 107.058 10.8889 107.058 12.3611C107.058 13.9167 105.811 14.9444 103.636 14.9444C102.157 14.9444 101.2 14.75 99.9536 14.1667L100.708 12.5833Z"
        fill="#808184"
      />
      <path d="M9.39512 0H0V4.5H9.39512V0Z" fill="#0060AE" />
      <path
        d="M14.0927 4.5V13.5H4.69756V18H0V9H9.39512V4.5H14.0927Z"
        fill="#0088CF"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="107" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
    <path d="M9.48293 0H0V4.75H9.48293V0Z" fill="#0060E5"/>
    <path d="M14.2244 4.75V14.25H4.74146V19H0V9.5H9.48293V4.75H14.2244Z" fill="#004CE0"/>
  </svg>

</template>

<script>
export default {
  name: "Logo",
  props: {
    size: {
      type: String,
      default: "large"
    }
  }
};
</script>
